module.exports = __webpack_public_path__ + "static/media/30x30-14.69c339a4.png";